module.exports = __webpack_public_path__ + "images/category_lp/tablet_smartwatch/assessment_achievements/5_371c33f72cfccf5569ceb9d970c02828.png";